// Runtime environment configuration helper
// Provides access to environment variables set at runtime via window.env

interface RuntimeEnv {
  VITE_BASE_URL: string;
  VITE_WEBSITE_URL: string;
  VITE_PAGE_CONTENT_PREVIEW_TOKEN: string;
}

// Window.env interface already declared in vite-env.d.ts and window.d.ts

// Fallback to build-time environment variables if runtime config is not available
const getRuntimeEnv = (): RuntimeEnv => {
  // Check if window.env is available (runtime config)
  if (typeof window !== 'undefined' && window.env) {
    return {
      VITE_BASE_URL: (window.env as any).VITE_BASE_URL || (window.env as any).API_URL || import.meta.env.VITE_BASE_URL || 'http://localhost:4000',
      VITE_WEBSITE_URL: (window.env as any).VITE_WEBSITE_URL || import.meta.env.VITE_WEBSITE_URL || 'https://website-black-beta-68.vercel.app',
      VITE_PAGE_CONTENT_PREVIEW_TOKEN: (window.env as any).VITE_PAGE_CONTENT_PREVIEW_TOKEN || import.meta.env.VITE_PAGE_CONTENT_PREVIEW_TOKEN || '',
    };
  }

  // Fallback to build-time environment variables
  return {
    VITE_BASE_URL: import.meta.env.VITE_BASE_URL || 'http://localhost:4000',
    VITE_WEBSITE_URL: import.meta.env.VITE_WEBSITE_URL || 'https://website-black-beta-68.vercel.app',
    VITE_PAGE_CONTENT_PREVIEW_TOKEN: import.meta.env.VITE_PAGE_CONTENT_PREVIEW_TOKEN || '',
  };
};

const runtimeEnv = getRuntimeEnv();

// Helper function to derive API URL from base URL
export const getApiUrl = (): string => {
  return `${runtimeEnv.VITE_BASE_URL}/api`;
};

// The public marketing site — used by the Website Content editor's live
// preview iframe and to seed a page's editor from its bundled defaults.
export const getWebsiteUrl = (): string => {
  return runtimeEnv.VITE_WEBSITE_URL.replace(/\/$/, '');
};

// Shared secret gating the live-preview iframe — see website/src/lib/pageContent.ts.
export const getPreviewToken = (): string => {
  return runtimeEnv.VITE_PAGE_CONTENT_PREVIEW_TOKEN;
};

export { runtimeEnv };